<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-select v-model="queryParam.commId" clearable filterable placeholder="请选择小区">
                    <el-option v-for="item in optionList" :key="item.commId" :label="item.commName" :value="item.commId" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.customerName" size="mini" clearable placeholder="请输入姓名查找" />
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.phone" size="mini" clearable placeholder="请输入电话查找" />
            </div>
            <div class="shaixuan-item">
                <el-select v-model="queryParam.pay_type" clearable placeholder="请选择支付方式">
                    <el-option v-for="item in paytypeList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </div>
             <div class="shaixuan-item">
                <!-- <span>积分范围：</span> -->
                <el-input v-model="queryParam.begin_score" size="mini" clearable placeholder="开始积分" style="width: 130px; margin-right: 10px" type="Number"/>
                <span>-</span>
                <el-input v-model="queryParam.end_score" size="mini" clearable placeholder="结束积分" style="width: 130px; margin-left: 10px" type="Number"/>
            </div>
            <div class="shaixuan-item">
                <el-date-picker v-model="publish_time" type="daterange" align="right" start-placeholder="支付时间起"
                    end-placeholder="支付时间止" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div class="shaixuan-item">
                <el-button type="primary" style="background: #1890ff; border-color: #1890ff" @click="searchClick()"
                    icon="el-icon-search">
                    查询
                </el-button>
                <el-button @click="exportData()" type="primary" style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-document-checked">
                    导出
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table v-loading="listLoading" :data="tableData" size="mini" style="width: 100%; min-height: 300px">
                <el-table-column prop="id" label="id" width="80" />
                <el-table-column prop="order_sn" label="订单号" width="150" />
                 <el-table-column prop="commName" label="小区" minWidth="140">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.userresource.commName
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customerName" label="客户姓名" width="100" />
                <el-table-column prop="phone" label="联系电话" minWidth="120">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.user.phone
                            }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="支付方式" minWidth="120">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.pay_type == 1">微信</el-tag>
                        <el-tag type="primary" v-if="scope.row.pay_type == 2">混合</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="user_score" label="用户积分" minWidth="100" />
                <el-table-column prop="yinbao_score" label="食堂积分" minWidth="100" />
                <el-table-column prop="youzan_score" label="商城积分" minWidth="100" />
                <el-table-column label="账单金额(元)" minWidth="100">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.price * 1 / 100
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="积分总抵扣(元)" minWidth="100">
                    <template slot-scope="scope">
                        <span>{{
                            (scope.row.price * 1 - scope.row.pay_price * 1 - scope.row.yinbao_balance * 1) / 100
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="食堂余额抵扣(元)" minWidth="120">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.yinbao_balance * 1 / 100
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="最终支付金额(元)" minWidth="120">
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.pay_price * 1 / 100
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pay_at" label="支付时间" minWidth="150" />

                <el-table-column fixed="right" align="center" label="操作" width="120">
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button type="danger" style="background: #1067e0;border-color: #1067e0;"
                                @click="clickItem(scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination v-show="total" :total="total" :page.sync="queryParam.page" :limit.sync="queryParam.size"
                @pagination="getList" />
        </div>
        <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="60%">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">详情</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <feiInfo ref="feiInfo" @onUpdateDrawer="onUpdateDrawer($event)" />
            </div>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/sell";
import wuye from "@/api/tianzheng/wuye";
import Qu from "@/api/tianzheng/Qu";
import feiInfo from "./feiInfo.vue";
import Pagination from "@/components/Pagination"; // 分页
export default {
    data() {
        return {
            optionList: [],
            publish_time: [],
            queryParam: {
                commId: "",//小区id
                customerName: "",//姓名
                phone: "",//电话
                bgn_date: "",
                end_date: "",
                page: 1,
                size: 10,
                pay_type:0,
                begin_score: "",
                end_score: ""
            },
            paytypeList:[
                {id:0,name:"全部"},
                {id:1,name:"微信"},
                {id:2,name:"混合"}
            ],
            total: 0,
            listLoading: false,
            tableData: [],
            showDrawer: false
        };
    },
    components: {
        Pagination,
        feiInfo
    },
    created() { },
    mounted() {
        this.getList();
        this.getSelectCity()
    },
    methods: {
        // 获取小区下拉列表
        getSelectCity() {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            })
        },
        // 导出
        exportData() {
            let that = this
            if (that.publish_time !== '' && that.publish_time !== null && that.publish_time !== undefined) {
                that.queryParam.bgn_date = that.publish_time[0]
                that.queryParam.end_date = that.publish_time[1]
            } else {
                that.queryParam.bgn_date = ''
                that.queryParam.end_date = ''
            }
            console.log(that.queryParam)
                wuye.exportData(that.queryParam).then((res) => {
                    if (res.code == 200) {
                        console.log(res)
                        if (res.result) {
                            that.$message.success(res.message);
                            // window.open(res.result)
                        }
                    } 
                }).catch(err => {
                    console.log("报错信息", err);
                })
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            console.log("status", status);
            if (status == 1) {
                // 刷新列表
                this.showDrawer = false;
                this.getList();
            } else if (status == -1) {
                // 关闭弹窗
                this.showDrawer = false;
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false;
        },
        /**
         * @name: 点击详情
         * @param {*} id
         * @return {*}
         * @desc:
         */
        clickItem(row) {
            let that = this;
            this.showDrawer = true;
            // 给组件传值
            let obj = {
                id: row ? row.id : ""
            };
            this.$nextTick(function () {
                that.$refs.feiInfo.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            if (that.publish_time !== '' && that.publish_time !== null && that.publish_time !== undefined) {
                that.queryParam.bgn_date = that.publish_time[0]
                that.queryParam.end_date = that.publish_time[1]
            } else {
                that.queryParam.bgn_date = ''
                that.queryParam.end_date = ''
            }
            this.listLoading = true;
            wuye.list(that.queryParam).then(res => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}
</style>
